import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { ShowsListComponent } from './features/shows-list/shows-list.component';
import { LoginComponent } from './features/login/login.component';
import { adminAuthGuard } from './core/guards/admin-auth.guard';
import { adminLoginGuard } from './core/guards/admin-login.guard';
import { ShowDetailComponent } from './features/show-detail/show-detail.component';
import { BlocklistNamesComponent } from './features/blocklist-names/blocklist-names.component';

export const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [adminLoginGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        canActivate: [adminAuthGuard],
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'showsList' },
            { path: 'showsList', component: ShowsListComponent },
            { path: 'showsList/:id', component: ShowDetailComponent },
            { path: 'blocklist-names', component: BlocklistNamesComponent }
        ]
    },
    {
        path: '**',
        redirectTo: ''
    }
];